import React from "react";
import styles from "./HeaderSearch.module.scss";
import {useTranslation} from "react-i18next";

type PrevSearchItemType = {
  term: string;
  searchPrevSearchItem: (query: string) => void;
  removePrevSearchItem: (query: string) => void;
};

const PrevSearchItem: React.FC<PrevSearchItemType> = ({removePrevSearchItem, searchPrevSearchItem, term}) => {
  const {t} = useTranslation();

  return (
    <div className={`${styles.suggestItem} ${styles.suggestItemStored}`}>
      <span
        className={styles.suggestItemStoredLink}
        onClick={() => searchPrevSearchItem(term)}
        title={t("search.searchAgain--query", {query: term})}
        role={"link"}
      >
        <span className={styles.suggestItemStoredIdentifier}>
          <i className="icon icon-clock icon-size--20" />
        </span>
        <span>{term}</span>
      </span>
      <span
        className={styles.suggestItemStoredRemove}
        onClick={() => removePrevSearchItem(term)}
        title={t("general.delete")}
      >
        <i className={`icon icon-close icon-size--22 ${styles.inputButtonRemoveIcon}`} />
      </span>
    </div>
  );
};

export default PrevSearchItem;
